var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSimpleRoundedOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#C8CAC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2414 23.875H10.75C10.5842 23.875 10.4253 23.8091 10.3081 23.6919C10.1908 23.5747 10.125 23.4158 10.125 23.25V19.7586C10.1251 19.593 10.1908 19.4343 10.3078 19.3172L19.9422 9.68281C20.0594 9.56568 20.2183 9.49989 20.384 9.49989C20.5497 9.49989 20.7086 9.56568 20.8258 9.68281L24.3172 13.1719C24.4343 13.2891 24.5001 13.448 24.5001 13.6137C24.5001 13.7794 24.4343 13.9383 24.3172 14.0555L14.6828 23.6922C14.5657 23.8092 14.4069 23.8749 14.2414 23.875Z",
    stroke: "#8F9195",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 12L22 16.375",
    stroke: "#8F9195",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSimpleRoundedOutline);
export default __webpack_public_path__ + "static/media/PencilSimpleRoundedOutline.58ac2e3e4a9299dd34bac8810f5ab332.svg";
export { ForwardRef as ReactComponent };